import { Component, OnInit, Input } from '@angular/core';


@Component({
  standalone: true,
  selector: 'app-item-help',
  imports: [],
  templateUrl: './item-help.component.html',
  styleUrls: ['./item-help.component.scss'],
})
export class ItemHelpComponent implements OnInit {
  @Input() data: any;
  constructor() {}

  ngOnInit(): void {}
}
